import React, { Fragment, useContext, useState } from "react";
import { PropTypes } from "prop-types";
import { Stack } from "@mui/material";

import CustomModal from "../../../react_utils/modals/CustomModal";
import TimePicker from "../../../react_utils/TimePicker";
import ModalFooter from "../../../react_utils/modals/ModalFooter";
import { MessagingContext } from "../../MessagingContext";
import useHeatpumpSgReadyTime from "../../../shared/hooks/heatpump/useHeatpumpSgReadyTime";

export default function HeatpumpSgReadyTimeModal({
  heatpump,
  setSgReadyTime,
  modalProps = {},
}) {
  const { showMessage } = useContext(MessagingContext);
  const [isFocused, setIsFocused] = useState(false);

  const { time, onSubmit } = useHeatpumpSgReadyTime(
    heatpump,
    setSgReadyTime,
    showMessage,
    isFocused,
  );

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const getFooter = (toggle) => {
    return (
      <ModalFooter
        buttons={[{ label: "Speichern", onClick: () => onSubmit(toggle) }]}
      />
    );
  };

  return (
    <Fragment>
      <CustomModal
        size="sm"
        title={"Anschaltzeit für SG-Ready einschränken"}
        getFooter={getFooter}
        {...modalProps}
        onToggle={onToggle}
      >
        <Stack spacing={2} marginY={"10px"}>
          <TimePicker
            time={time.lower.value}
            setTime={time.lower.setValue}
            label="Früheste Anschaltzeit für SG-Ready"
            showClearIcon={!!time.lower.value}
          />
          <TimePicker
            time={time.higher.value}
            setTime={time.higher.setValue}
            label="Späteste Anschaltzeit für SG-Ready"
            showClearIcon={!!time.higher.value}
          />
        </Stack>
      </CustomModal>
    </Fragment>
  );
}

HeatpumpSgReadyTimeModal.propTypes = {
  heatpump: PropTypes.object,
  setSgReadyTime: PropTypes.func,
  modalProps: PropTypes.object,
};
